/**
 * API Client
 * 
 * This file creates and exports the Axios client instance for API calls.
 */

import axios from 'axios';
import { setupInterceptors } from './interceptors';

// 使用 env-cmd 配置的環境變數
const API_DOMAIN = (process.env.REACT_APP_API_DOMAIN || '').trim(); // e.g. http://10.100.4.129
const API_PORT = (process.env.REACT_APP_API_PORT || '').trim();     // e.g. 8080 (通常留空)
const API_PREFIX_RAW = (process.env.REACT_APP_API_PREFIX || '').trim(); // e.g. api 或 /api

// prefix 一律去掉開頭的 /
const API_PREFIX = API_PREFIX_RAW.replace(/^\/+/, ''); // "/api" -> "api"

// 構建 API Base URL
// baseURL 規則：
// - 有 API_DOMAIN：用 http://host(:port)/prefix
// - 沒 API_DOMAIN：用 /prefix（同源，最推薦搭 nginx 反代）
const API_BASE_URL = API_DOMAIN
  ? `${API_DOMAIN}${API_PORT ? `:${API_PORT}` : ''}${API_PREFIX ? `/${API_PREFIX}` : ''}`
  : (API_PREFIX ? `/${API_PREFIX}` : '');

// Create a custom Axios instance with default settings
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, application/pdf',
  },
  responseType: 'json', // Default response type
});

// Log API configuration in development environment
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    API_DOMAIN,
    API_PORT,
    API_PREFIX,
    API_BASE_URL
  });
}

// Setup request and response interceptors
setupInterceptors(apiClient);

// Export default instance for direct imports
export default apiClient;
